import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { navEnable } from '../../actions/nav';
import FormField from 'grommet/components/FormField';
import TextInput from 'grommet/components/TextInput';
import Footer from 'grommet/components/Footer';
import Form from 'grommet/components/Form';
import Button from 'grommet/components/Button';
import Header from 'grommet/components/Header';
import Headline from 'grommet/components/Headline';
import { addStemIDAction, createStemAction, showAddStemError, setStemName, setStemLocation, hideToast } from '../../actions/dashboard'
import Toast from 'grommet/components/Toast';
import constants from '../../Constants';
import EditControl from '../site/Controls';

var twigObj = {};
var refs

class AddStems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stemID: ''
        }
        this.addStemId = this.addStemId.bind(this)
        this.onStemIDChange = this.onStemIDChange.bind(this)
        this.createStem = this.createStem.bind(this)
        this.cancelCreate = this.cancelCreate.bind(this)
        this.hideErrorDetails = this.hideErrorDetails.bind(this)
        this.controlValueChange = this.controlValueChange.bind(this)
        this.closeToast = this.closeToast.bind(this)
    }


    componentWillMount() {
        this.props.dispatch(navEnable(true));
    }

    componentWillReceiveProps(nextProps) {
        twigObj['twigId'] = nextProps.twigId
        this.setState({ stemID: ''});
    }

    componentWillUnmount() {
        this.hideErrorDetails();
        this.cancelCreate();
    }

    componentDidmount() {
        this.hideErrorDetails();
        this.cancelCreate();
    }


    addStemId() {
        twigObj = {};
        this.props.dispatch(setStemName(''));
        this.props.dispatch(setStemLocation(''));
        this.props.dispatch(hideToast());
        if (this.state.stemID && this.state.stemID.trim() !== ''){
            this.props.dispatch(addStemIDAction({stemID : this.state.stemID.toLowerCase(), showStemAddForm: true}));
        }
        else{
            this.setState({ errorMessage: "Can't be blank" })
        }
    }

    onStemIDChange(e) {
        this.setState({
            stemID: e.target.value,
            errorMessage: ''
        })
    }

    hideErrorDetails () {
        this.props.dispatch(showAddStemError(null));
    }

    closeToast() {
        this.props.dispatch(hideToast());
    }

    renderToast() {
        return (
            <Toast status='ok'onClose={this.closeToast}>
                {this.props.toastMessage}
            </Toast>
        )
    }
    controlValueChange(controlInfo, event) {
        this.hideErrorDetails();
        let value = '';
        if (controlInfo.controlType == constants.TWIG_EDIT_CONTROLS.NUMBER_ARRAY) {
            value = event;
        }
        else if(controlInfo.key === "siteName") {
            value = event.target ? event.target.value : event;
        }
        else {
            value = event.target ? event.target.value : event;
            if(event.target.name === "Stem Name"){
                this.props.dispatch(setStemName(value));
            }
            else if(event.target.name === "Stem Location"){
                this.props.dispatch(setStemLocation(value));
            }
        }
        twigObj[controlInfo.key] = value;
    }

    setValue (label) {
        if(label === "Stem Name"){
            return this.props.stemName;
        }
        else{
            return this.props.stemLocation;
        }
    }

    renderTwigControls() {
        let controlsArr = [];
        let staticControl = [{ type: 'name', key: 'name' }, { type: 'locationName', key: 'location' }]
        for (let i = 0; i < staticControl.length; i++) {
            let label = staticControl[i].type == 'name' ? 'Stem Name' : 'Stem Location';
            controlsArr.push(
                <EditControl name = {label} controlType={constants.TWIG_EDIT_CONTROLS.TEXT} label={label}
                    value={this.setValue(label)} key={staticControl[i].key}
                    controlKey={staticControl[i].key} controlValueChange={this.controlValueChange} />
            )
        }
        let selectControl = [{ type: 'PlantType', key: 'plantType' },
        { type: 'SiteName', key: 'siteName' }, { type: 'SoilType', key: 'soilType' }];
        for (let i = 0; i < selectControl.length; i++) {
            controlsArr.push(<EditControl parseClass={selectControl[i].type}
                hasUser={selectControl[i].type == 'SiteName' ? true : false}
                controlType={constants.TWIG_EDIT_CONTROLS.SELECT}
                label={selectControl[i].type}
                key={selectControl[i].key} controlKey={selectControl[i].key}
                                          ref={selectControl[i].key}
                controlValueChange={this.controlValueChange} isCreate={true} />)
        }

        return controlsArr
    }

    createStem(event) {
        if(twigObj && (!twigObj.name || !twigObj.name.trim())){
            twigObj.name = twigObj.twigId ? twigObj.twigId.substr(-8): '';
        }
        if(twigObj && !twigObj.location) {
          twigObj.location = '';
        }
        twigObj.siteName = this.refs.siteName.state.value;
        if(twigObj && !twigObj.siteName) {
            twigObj.siteName = 'unknown site';
        }
        twigObj.plantType = this.refs.plantType.state.value;
        if(twigObj && !twigObj.plantType) {
            twigObj.plantType = 'Walnuts';
        }
        twigObj.soilType = this.refs.soilType.state.value;
        if(twigObj && !twigObj.soilType) {
            twigObj.soilType = 'Clay Loam';
        }
        this.props.dispatch(createStemAction(twigObj));
    }
    cancelCreate() {
        this.props.dispatch(setStemName(''));
        this.props.dispatch(setStemLocation(''));
        this.hideErrorDetails();
        const data = {
            data :[
                {
                    twigId : null
                }
            ],
            success : false
        }
        this.props.dispatch(addStemIDAction({data, showStemAddForm: false}));
    }

    showError() {
        if(this.props.showAddStemError) {
            if(this.props.showAddStemError.action && this.props.showAddStemError.action==="createStem") {
                return (<div className="error">{this.props.showAddStemError.message || "Oops!! Something went wrong. Request failed"}</div>);
            }
            else if(this.props.showAddStemError.duplicateStemError) {
                return (<div className="error">{this.props.showAddStemError.message}</div>)
            }
            else {
                return (<div className="error">{this.props.showAddStemError.message || "Oops!! Something went wrong. Request failed"}</div>);
            }
        }
        else {
            return '';
        }

    }

    render() {
        return (<div>
            {this.props.showToast ? this.renderToast() : ''}
            <Form pad='large'>
                <Header>
                    <Headline size='small'>
                        Add Stem
                    </Headline>
                </Header>
                <div style={{ display: this.props.showStemAddForm ? 'none' : '' }}>
                    <FormField >
                        <TextInput onDOMChange={this.onStemIDChange} onFocus={this.hideErrorDetails} maxLength={8}
                            ref="stem_id" value={this.state.stemID} placeHolder={"Enter stem ID"} />
                        <span className="error">{this.state.errorMessage}</span>
                    </FormField>
                    <Footer pad={{ "vertical": "medium" }}>
                        <Button label='Go'
                            primary={true}
                            onClick={this.addStemId}
                        />
                    </Footer>
                </div>
                <div className="edit-twig-content"
                    style={{ display: this.props.showStemAddForm ? '' : 'none' }}>
                    {this.renderTwigControls()}
                    <div className="overlay-btn-container">
                        <Button label='Add'
                            primary={true}
                            onClick={this.createStem}
                        />

                        <Button
                            label='Cancel'
                            onClick={this.cancelCreate}
                            primary={true} style={{ maginLeft: '10px' }} />
                    </div>
                </div>
                {this.showError()}
            </Form>
        </div>
        )
    }


}

// AddStems.prototype = {

// }

let mapStateToProps = (state) => ({
    twigId: state.dashboard.twigId,
    showStemAddForm: state.dashboard.showStemAddForm,
    showToast: state.dashboard.showToast,
    toastMessage: state.dashboard.toastMessage,
    showAddStemError: state.dashboard.showAddStemError,
    stemName : state.dashboard.stemName,
    stemLocation: state.dashboard.stemLocation
})

export default connect(mapStateToProps)(AddStems)


// WEBPACK FOOTER //
// ./src/js/components/dashboard/AddStem.js